import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { useCurrentOrg } from 'auth/hooks'
import { adminLocaleLabelKey, resolveOrgAdminLocales } from 'i18n/adminLocales'

const LanguageMenuItems = ({ linkClassName, labelClassName, onLanguageChange }) => {
  const { t, i18n } = useTranslation('common')
  const organization = useCurrentOrg()
  const { supportedAdminLocales } = resolveOrgAdminLocales(organization)
  const current = i18n.language.split('-')[0]

  return (
    <>
      <span className={labelClassName}>{t('language.label')}</span>
      {supportedAdminLocales.map(locale => (
        <button
          type="button"
          key={locale}
          className={cn(linkClassName, { active: current === locale })}
          onClick={() => {
            void i18n.changeLanguage(locale)
            onLanguageChange?.()
          }}
        >
          {t(adminLocaleLabelKey(locale))}
          {current === locale ? ' ✓' : ''}
        </button>
      ))}
    </>
  )
}

LanguageMenuItems.propTypes = {
  linkClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onLanguageChange: PropTypes.func,
}

export default LanguageMenuItems
